class ProductDataTable {
  constructor(productId, productVariants) {
    this.productId = productId;
    this.productVariants = productVariants;
    this.productDataTable = document.querySelector(`#product-data-table-${this.productId}`);

    if (!this.productDataTable) {
      return;
    }

    this.variantGroups = this.productDataTable.querySelectorAll('.product-data-table__variant[data-variant-group]');

    this.init();
  }

  init() {
    this.addRowClickListeners();
    this.setupObserver();
    this.setupEventListeners();

    setTimeout(() => this.updateTableVisibility(), 500);
  }

  updateTableVisibility() {
    let variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) {
      variantPicker = document.querySelector('variant-selects');
    }

    if (!variantPicker) {
      this.variantGroups.forEach((group) => {
        group.classList.remove('hidden');
      });
      return;
    }

    const firstFieldset = variantPicker.querySelector('fieldset');
    if (!firstFieldset) {
      this.variantGroups.forEach((group) => {
        group.classList.remove('hidden');
      });
      return;
    }

    let selectedOption = firstFieldset.querySelector('input[type="radio"]:checked');

    if (!selectedOption) {
      this.variantGroups.forEach((group) => {
        group.classList.remove('hidden');
      });
      return;
    }

    let selectedVariantId = selectedOption.dataset.variantId;

    if (!selectedVariantId) {
      this.variantGroups.forEach((group) => {
        group.classList.remove('hidden');
      });
      return;
    }

    const selectedVariant = this.productVariants.find(
      (variant) => variant.id.toString() === selectedVariantId || variant.id === parseInt(selectedVariantId)
    );

    if (!selectedVariant) {
      this.variantGroups.forEach((group) => {
        group.classList.remove('hidden');
      });
      return;
    }

    const selectedGroup = selectedVariant.option1;

    this.variantGroups.forEach((group) => {
      group.classList.add('hidden');
    });

    let targetGroup = null;
    this.variantGroups.forEach((group) => {
      if (group.dataset.variantGroup === selectedGroup) {
        targetGroup = group;
      }
    });

    if (targetGroup) {
      targetGroup.classList.remove('hidden');
      this.updateActiveRow(targetGroup, selectedVariantId);
    } else {
      this.variantGroups.forEach((group) => {
        group.classList.remove('hidden');
      });
    }
  }

  updateActiveRow(targetGroup, selectedVariantId) {
    const rows = targetGroup.querySelectorAll('tbody tr[data-variant-id]');
    rows.forEach((row) => {
      row.classList.remove('active');
      if (row.dataset.variantId === selectedVariantId) {
        row.classList.add('active');
      }
    });
  }

  handleRowClick(event) {
    const row = event.currentTarget;
    const variantId = row.dataset.variantId;
    const variantAvailable = row.dataset.variantAvailable === 'true';

    if (!variantId) {
      return;
    }

    if (!variantAvailable) {
      return;
    }

    const selectedVariant = this.productVariants.find(
      (variant) => variant.id.toString() === variantId || variant.id === parseInt(variantId)
    );

    if (!selectedVariant) {
      return;
    }

    this.selectVariantByUrl(selectedVariant);
    this.selectVariantByInputs(variantId, selectedVariant);
    this.selectVariantByAPI(selectedVariant);

    const targetGroup = row.closest('.product-data-table__variant');
    if (targetGroup) {
      this.updateActiveRow(targetGroup, variantId);
    }

    if (selectedVariant) {
      const variantSelectedEvent = new CustomEvent('variant:selected', {
        bubbles: true,
        detail: {
          resource: { id: variantId },
        },
      });
      document.dispatchEvent(variantSelectedEvent);

      const variantUpdateEvent = new CustomEvent('variant:update', {
        bubbles: true,
        detail: {
          resource: selectedVariant,
          sourceId: 'product-data-table',
          data: {
            productId: this.productId,
            html: null,
          },
        },
      });
      document.dispatchEvent(variantUpdateEvent);
    }
  }

  selectVariantByUrl(selectedVariant) {
    const url = new URL(window.location.href);
    if (selectedVariant.id) {
      url.searchParams.set('variant', selectedVariant.id.toString());
      history.replaceState({}, '', url.toString());
    }

    const variantPicker = document.querySelector('variant-picker') || document.querySelector('variant-selects');
    if (!variantPicker) {
      return;
    }

    const targetOptions = [selectedVariant.option1, selectedVariant.option2, selectedVariant.option3].filter(Boolean);

    targetOptions.forEach((optionValue, index) => {
      const inputs = variantPicker.querySelectorAll('input[type="radio"]');

      for (const input of inputs) {
        if (input instanceof HTMLInputElement) {
          if (input.value === optionValue) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
    });
  }

  selectVariantByInputs(variantId, selectedVariant) {
    const variantPicker = document.querySelector('variant-picker') || document.querySelector('variant-selects');

    if (!variantPicker) {
      return;
    }

    let variantFound = false;

    const radioInputs = variantPicker.querySelectorAll('input[type="radio"]');

    for (const input of radioInputs) {
      if (input instanceof HTMLInputElement) {
        if (input.dataset.variantId === variantId) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          variantFound = true;
          break;
        }
      }
    }

    if (!variantFound) {
      const selectElements = variantPicker.querySelectorAll('select');

      for (const select of selectElements) {
        if (select instanceof HTMLSelectElement) {
          const options = select.querySelectorAll('option');

          for (const option of options) {
            if (option instanceof HTMLOptionElement) {
              if (option.dataset.variantId === variantId) {
                select.value = option.value;
                option.selected = true;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                variantFound = true;
                break;
              }
            }
          }
          if (variantFound) break;
        }
      }
    }
  }

  selectVariantByAPI(selectedVariant) {
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker && variantPicker.updateSelectedOption) {
      const inputs = variantPicker.querySelectorAll('input[type="radio"]');
      for (const input of inputs) {
        if (input instanceof HTMLInputElement) {
          const inputValue = input.value;
          if (
            inputValue === selectedVariant.option1 ||
            inputValue === selectedVariant.option2 ||
            inputValue === selectedVariant.option3
          ) {
            try {
              variantPicker.updateSelectedOption(input);
              return;
            } catch (e) {
              // Continue with fallback
            }
          }
        }
      }
    }

    const variantSelectedEvent = new CustomEvent('variant:selected', {
      bubbles: true,
      detail: {
        resource: { id: selectedVariant.id },
      },
    });
    document.dispatchEvent(variantSelectedEvent);
  }

  addRowClickListeners() {
    const rows = this.productDataTable.querySelectorAll('tbody tr[data-variant-id]');
    rows.forEach((row, index) => {
      row.removeEventListener('click', this.handleRowClick.bind(this));
      row.addEventListener('click', this.handleRowClick.bind(this));

      row.setAttribute('tabindex', '0');
      row.setAttribute('role', 'button');
      row.setAttribute('aria-label', `Select variant ${row.dataset.variantTitle || 'option ' + (index + 1)}`);

      row.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.handleRowClick(event);
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          const nextRow = rows[index + 1] || rows[0];
          nextRow.focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          const prevRow = rows[index - 1] || rows[rows.length - 1];
          prevRow.focus();
        }
      });

      const isAvailable = row.dataset.variantAvailable === 'true';
      row.style.cursor = isAvailable ? 'pointer' : 'not-allowed';

      if (!isAvailable) {
        row.setAttribute('aria-disabled', 'true');
      }
    });
  }

  setupObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          this.addRowClickListeners();
        }
      });
    });

    observer.observe(this.productDataTable, {
      childList: true,
      subtree: true,
    });
  }

  setupEventListeners() {
    const updateVisibility = () => this.updateTableVisibility();

    document.addEventListener('variant:update', updateVisibility);
    document.addEventListener('variant:selected', updateVisibility);

    document.addEventListener('change', (event) => {
      if (
        event.target &&
        event.target.matches &&
        event.target.matches(
          'variant-picker select, variant-picker input, variant-selects select, variant-selects input'
        )
      ) {
        setTimeout(updateVisibility, 100);
      }
    });
  }
}

window.initProductDataTable = function (productId, productVariants) {
  new ProductDataTable(productId, productVariants);
};
